import { FAQsItem } from '@mygpt/app/faqs/services/list';
import { Http } from '@mygpt/app/http';
import { MsgCitation } from '@mygpt/types';
import { I18N_LANG_MAP } from '@mygpt/app/chat/constant';

export interface AddFAQsParams {
  // 数据集 ID
  datasetId: string;
  question: string;
  answer: string;
  sources: string;
  language: string;
  session_message_id?: string;

  citation?: MsgCitation;
  hierarchy_parent_id?: string; // 父节点(树状用)
  is_search?: boolean; // 是否在问答里进行Q&A搜索
}

/**
 * 添加问答
 * @param params
 * @returns
 */
export const addFAQsService = (params: AddFAQsParams) => {
  const { datasetId, language, ...rest } = params;
  const { post } = Http.use();
  return post<FAQsItem>(`/datasets/${datasetId}/faqs`, {
    ...rest,
    language: I18N_LANG_MAP[language],
  });
};

interface BatchAddFAQsService {
  faqs: FAQsItem[];
  errors: { question: string; error: string }[];
}

/**
 * 批量添加问答
 * @param params
 * @returns
 */
export const batchAddFAQsService = (params: { datasetId: string; data: Omit<AddFAQsParams, 'datasetId'>[] }) => {
  const { data, datasetId } = params;
  const { post } = Http.use();
  return post<BatchAddFAQsService>(`/datasets/${datasetId}/faqs/batch`, data);
};
